import './GlobalPreferencePanel.scss';

import classNames from 'classnames';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverPortal,
} from '@radix-ui/react-popover';

import { ShowTo } from '../../ShowTo';
import { ShopBrand } from '../../../utils';
import { useMemo } from 'react';
import { isEnterKey } from '@travelwin/core';

export const globalPreferenceClassName = 'c-GlobalPreferencePanel';

export type SelectorId = 'language' | 'currency' | 'store';

export type SelectorType = {
  id: SelectorId;
  title: string;
  component: React.ReactNode;
  showTo: ShopBrand[];
  buttonLabel: React.ReactNode;
  isVisible: boolean;
};

export const GlobalPreferencePanelDropDown = ({
  onPanelToggle,
  isExpanded,
  anchor,
  selectors,
}: {
  onPanelToggle: (active: boolean) => void;
  isExpanded: boolean;
  anchor: React.ReactNode;
  selectors: SelectorType[];
}) => {
  const renderSelectors = useMemo(
    () => (
      <div className={`${globalPreferenceClassName}__selector-container`}>
        {selectors.map(({ id, title, component, showTo }: SelectorType) => (
          <ShowTo brands={showTo} key={id}>
            <div className={`${globalPreferenceClassName}__selector-list`}>
              <span
                data-testid="selector-title"
                className={`${globalPreferenceClassName}__selector-list-title`}
              >
                {title}
              </span>

              {component}
            </div>
          </ShowTo>
        ))}
      </div>
    ),
    [selectors],
  );

  return (
    <div
      className={`${globalPreferenceClassName}__dropdown`}
      onClick={() => onPanelToggle(!isExpanded)}
      onKeyDown={(e) => isEnterKey(e) && onPanelToggle(!isExpanded)}
    >
      <Popover
        open={isExpanded}
        onOpenChange={(open: boolean) => onPanelToggle(open)}
      >
        <PopoverTrigger>{anchor}</PopoverTrigger>

        <PopoverPortal>
          <PopoverContent
            collisionPadding={80}
            sideOffset={10}
            className={classNames(
              `${globalPreferenceClassName}__popover-content`,
              {
                [`${globalPreferenceClassName}__popover-content--focused`]:
                  isExpanded,
              },
            )}
          >
            {renderSelectors}
          </PopoverContent>
        </PopoverPortal>
      </Popover>
    </div>
  );
};
